const FreelancerAgencyUserTypesEnum=
{
    Agency: 'Agency',
    UserWithAgency:'UserWithAgency',
    IndependentUser:'IndependentUser'
};

export default FreelancerAgencyUserTypesEnum;